import {
  MissingTranslationHandler,
  TranslateModule,
} from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { RdMissingTranslationHandler } from '@rd/errors/missing-translations.handler';
import { environment } from '../environments/environment';

export const externalModules = [
  TranslateModule.forRoot({
    missingTranslationHandler: {
      provide: MissingTranslationHandler,
      useClass: RdMissingTranslationHandler,
    },
  }),
];

export const externalProviders = [
  provideTranslateHttpLoader({
    prefix: `${environment.translationBaseUrl}/`,
    suffix: '.json',
  }),
];
